/* eslint-disable react/jsx-no-bind */
import React, { useCallback, useState, useRef, useEffect } from 'react';
import { Card, Input, Button, Box, Flex } from 'pcln-design-system';
import sanitizeInput from './utils/sanitizeInput';
/**
 * DialogInputSection
 * Component for input and submit button
 * @public
 */
export const DialogInputSection = props => {
  var _a;
  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);
  const {
    isDisablingInput,
    isLoading,
    submitInputValue
  } = props;
  const submit = useCallback(() => {
    // Clear the value inside input box
    setInputValue('');
    // Create a user message
    const msg = {
      role: 'user',
      content: sanitizeInput(inputValue)
    };
    submitInputValue(msg);
  }, [inputValue]);
  function keyUpHandler(event) {
    var _a;
    if (event.key === 'Enter' && !isLoading && !isDisablingInput && ((_a = event.target.value) === null || _a === void 0 ? void 0 : _a.trim())) {
      submit();
    }
  }
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  return React.createElement(React.Fragment, null, React.createElement(Box, {
    bg: 'background.tint',
    width: 1,
    height: '1px'
  }), React.createElement(Flex, {
    p: 2,
    width: 1,
    bg: 'background.lightest'
  }, React.createElement(Card, {
    mr: 2,
    width: 'calc(100% - 90px)}',
    borderRadius: 24,
    boxShadowSize: 'sm'
  }, React.createElement(Input, {
    disabled: isDisablingInput,
    style: {
      backgroundColor: 'white',
      borderStyle: 'none',
      borderRadius: '24px'
    },
    id: 'chatInput',
    "data-testid": 'chatInput',
    autoComplete: 'off',
    value: inputValue,
    placeholder: 'Type your message here',
    onChange: event => {
      event.preventDefault();
      const target = event.target;
      setInputValue(target.value);
    },
    onBlur: event => {
      var _a;
      event.preventDefault();
      const target = event.target;
      setInputValue((_a = target.value) === null || _a === void 0 ? void 0 : _a.trim());
    },
    onKeyUp: keyUpHandler,
    ref: inputRef
  })), React.createElement(Button, {
    "data-testid": 'submitChatInput',
    disabled: isDisablingInput || isLoading || !((_a = inputValue === null || inputValue === void 0 ? void 0 : inputValue.trim()) === null || _a === void 0 ? void 0 : _a.length),
    onClick: event => {
      event.preventDefault();
      if (!isDisablingInput && !isLoading) {
        submit();
      }
    }
  }, "Submit")));
};